import { getLocale } from "../runtime";

const sv_hrcountryenglish = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Croatia`
};

const hrcountryenglish = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_hrcountryenglish(inputs)
	return "hrCountryEnglish";
};

export { hrcountryenglish as "hrCountryEnglish" };